import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10a13b4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-container" }
const _hoisted_2 = { class: "right-content" }
const _hoisted_3 = { class: "middle-container" }

import { ref } from 'vue';
import { Menu as MenuIcon } from '@element-plus/icons-vue';
import TopHead from './TopHead.vue';
import LeftMenu from './LeftMenu.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const drawer = ref(false);


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "menu-launch-icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = true))
    }, [
      _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [
          _createVNode(_unref(MenuIcon))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
      direction: "ltr",
      "lock-scroll": "",
      size: "250px"
    }, {
      default: _withCtx(() => [
        _createVNode(LeftMenu, {
          class: "left-menu-container",
          onMenuClicked: _cache[1] || (_cache[1] = ($event: any) => (drawer.value = false))
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(LeftMenu, { class: "pc-menu-container left-menu-container" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TopHead, { class: "header" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view, { class: "middle-wrapper" })
      ])
    ])
  ]))
}
}

})